// Native & external imports
import { Component, OnInit, OnDestroy, Input, inject } from "@angular/core";
import { Router } from "@angular/router";
import { CmpAuthService, ApiCallsService } from "icamppro-shared-components";
import { environment } from "src/environments/environment";
import { SubSink } from "subsink";
// Services
import { AppRouterService } from "src/routing/routes-service";
import { LayoutService } from "src/services/layout.service";
// Objects
import { CmpAlertModalObject } from "src/objects/cmp-alert.object";

@Component({
  standalone: false,
  selector: "cmp-top-navbar",
  templateUrl: "./top-navbar.component.html",
})
export class TopNavbarComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private authService = inject(CmpAuthService);
  private routerService = inject(AppRouterService);
  layoutService = inject(LayoutService);
  apiService = inject(ApiCallsService);

  @Input() logo = "";
  public assetPrefix = environment.assetPrefix;
  public alertModalObject = new CmpAlertModalObject();
  public accountOverview = false;
  private subSink = new SubSink();

  ngOnInit() {
    this.layoutService.isShadowAccount();
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

  /**
   * Redirect to members view, if the user is logged in and login page, if not
   * @returns void
   */
  public goHome() {
    this.authService.getToken().subscribe((response) => {
      if (response) {
        this.router.navigate([this.routerService.componentsUrl.dashboard]);
      } else {
        this.router.navigate([this.routerService.componentsUrl.base]);
      }
    });
  }
}
